module.exports = __webpack_public_path__ + "img/4.095274af.svg";